<template>
  <div class="banner banner--avatar">
    <div class="container">
      <div :style="bannerBg" class="banner__content rounded-10">
        <Avatar :url="avatar" variant="rounded" />
        <div class="banner__header">
          <h1 class="banner__title">Hi {{ subtitle }},</h1>
          <div class="banner__subtitle">{{ message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/icons/IconAvatar";

export default {
  components: {
    Avatar
  },
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    background: {
      type: String,
      default: require("@/assets/media/backgrounds/banner-default@2x.png")
    },
    avatar: {
      type: String,
      default: require("@/assets/media/avatars/avatar9.jpg")
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    bannerBg() {
      if (this.windowWidth < 640) {
        return {
          "background-color": "#F8F8F8"
        };
      }
      return {
        "background-image": `url(${this.background})`
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  }
};
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

.rounded {
  border-radius: 0;

  @include media-breakpoint-up(md) {
    border-radius: 0.375rem !important;
  }
}

.banner {
  margin-bottom: 1.5rem;

  @include media-breakpoint-up(md) {
    margin-bottom: 2.5rem;
  }

  &__content {
    background-color: #fdfdfd;
    background-position: 75%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    height: 9.375rem;
    padding: 1rem;
    position: relative;

    @include media-breakpoint-up(md) {
      background-position: 75% 50%;
      padding: 1rem 3.75rem;
    }

    @include media-breakpoint-up(lg) {
      background-position: 100% 50%;
    }
  }

  &__header {
    flex: 1;
    margin: auto 0;
  }

  &__title {
    font-size: 1.25rem;
    margin: 0;

    @include media-breakpoint-up(sm) {
      font-size: 1.5rem;
    }

    @include media-breakpoint-up(md) {
      font-size: 1.875rem;
    }
  }

  &__subtitle {
    font-size: 1rem;
    line-height: 1.15;

    @include media-breakpoint-up(sm) {
      font-size: 1.125rem;
    }

    @include media-breakpoint-up(md) {
      font-size: 1.5rem;
    }
  }
}

.avatar {
  border: 0.125rem solid $white;
  border-radius: 50%;
  box-shadow: 0 0.25rem 0.375rem 0 rgba(0, 0, 0, 0.04);
  margin: auto 1.25rem auto 0;
  display: block;
  width: 48px;
  height: 48px;

  @include media-breakpoint-up(md) {
    border: 0.1875rem solid $white;
    height: 4.375rem;
    margin: auto 2.5rem auto 0;
    width: 4.375rem;
  }
}
</style>
